import React, { useState, useCallback } from 'react'

import Textarea from 'react-textarea-autosize';

import {ILabel, Label} from "./Label"


export const TextAreaLabeled : React.FC<Props> = (props : Props) : JSX.Element => {

    let [value, setValue] = useState(props.value === undefined ? "" : props.value);
    const onChange = useCallback((event) => { setValue(event.value); }, [value]);


    return (
            <div className="input-container">
                { props.label === undefined ?
                null : 
                <Label
                label = {props.label}
                isRequired = {props.isRequired}
                />
                }
                <Textarea onChange={onChange}
                        onBlur={props.onBlur}
                        name={props.name}
                        value={value} 
                        placeholder={props.placeholder} 
                        width={'100%'} 
                        cols={70} 
                        rows={6} 
                        maxLength={props.maxLength}
                        style={{maxHeight: props.height, minHeight : props.height , 'fontFamily':'Arial', overflow:'hidden', resize:'none'}} 
                />
            </div>
    )

}

// in this case, the state and its setter are defined on the parent element 
export const TextAreaLabeledStatic : React.FC<Props> = (props : Props) : JSX.Element => {

    return (
            <div className="input-container">
                { props.label === undefined ?
                null : 
                <Label
                label = {props.label}
                isRequired = {props.isRequired}
                />
                }
                <Textarea onChange={props.onChange}
                        name={props.name}
                        value={props.value} 
                        placeholder={props.placeholder} 
                        width={'100%'} 
                        cols={70} 
                        rows={6} 
                        maxLength={props.maxLength}
                        style={{maxHeight: props.height, minHeight : props.height , 'fontFamily':'Arial', overflow:'hidden', resize:'none'}} 
                />
            </div>
    )

}



interface Props {
    readonly label : ILabel | undefined;
    readonly isRequired : boolean | undefined;
    readonly onBlur : React.FocusEventHandler<HTMLInputElement> | undefined;
    readonly onChange : React.ChangeEventHandler | undefined;
    readonly placeholder : string | undefined;
    readonly name : string;
    readonly value : string | undefined;
    readonly maxLength : string | undefined;
    readonly height : string | undefined;
    readonly kmsRef : React.RefObject<unknown> | undefined
}